module.exports = "/_next/static/images/img__bottom__right__desktop-f901df3e3aa14f540a72a467b9baeaef.png";